import posthog from 'posthog-js'

const CHUNK_RELOAD_ATTEMPTED_KEY = 'chunk_reload_attempted';

function recoverFromChunkLoadError(error: unknown) {
    if (typeof error !== 'string' && (typeof error !== 'object' || error === null)) {
        return;
    }

    const name = typeof error === 'object' && 'name' in error ? error.name : undefined;
    const message = typeof error === 'string' ? error : 'message' in error ? error.message : undefined;
    if (name !== 'ChunkLoadError' &&
        !(typeof message === 'string' && /^(?:ChunkLoadError: )?Loading chunk [\w-]+ failed\./.test(message))) {
        return;
    }

    try {
        if (window.sessionStorage.getItem(CHUNK_RELOAD_ATTEMPTED_KEY)) {
            return;
        }
        window.sessionStorage.setItem(CHUNK_RELOAD_ATTEMPTED_KEY, 'true');
    } catch (storageError) {
        console.warn('Cannot safely reload after a chunk load failure: session storage is unavailable.', storageError);
        return;
    }

    try {
        if (isKick || isRumble) {
            posthog.capture('chunk_reload_attempted', {
                error_name: name,
                error_message: message,
            }, {transport: 'sendBeacon', send_instantly: true});
        }
    } catch (captureError) {
        console.error('Could not capture the chunk reload attempt.', captureError);
    }

    window.location.reload();
}

window.addEventListener('error', event => recoverFromChunkLoadError(event.error));
window.addEventListener('unhandledrejection', event => recoverFromChunkLoadError(event.reason));

const isKick = !process.env.NEXT_PUBLIC_PLATFORM || process.env.NEXT_PUBLIC_PLATFORM === 'kick';
const isRumble = process.env.NEXT_PUBLIC_PLATFORM === 'rumble';
if (isKick) {
    posthog.init('phc_BdX0R5qtQz8KVIcInJ3oQhbBQ4iiTpiSDfoGmN6gtJn', {
        api_host: 'https://us.i.posthog.com',
        person_profiles: 'identified_only',
        opt_in_site_apps: true,
        capture_pageview: 'history_change',
        capture_pageleave: true,
        autocapture: false,
        logs: {
            serviceName: 'kick-video-download-frontend',
        },
    });

    try{
        window.posthog=posthog
    }catch(err){

    }
}
if (isRumble) {
    posthog.init('phc_TKzGo0UELmkcm1tvyc6zrYsl277mzjp2y1i40VZS5HE', {
        api_host: 'https://t.rumble-video.download',
        person_profiles: 'identified_only',
        ui_host: 'https://us.posthog.com',
        defaults: '2026-05-30',
        opt_in_site_apps: true,
        capture_pageview: 'history_change',
        capture_pageleave: true,
        autocapture: false,
        logs: {
            serviceName: 'rumble-video-download-browser',
        },
    });

    try{
        window.posthog=posthog
    }catch(err){

    }
}
